import React from "react";
import classNames from "classnames";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import { LogRenderContext } from "../LogRenderer";
import { MediaInfoBlock } from "../createEvents/MediaTab";
import GetUpdatedOnBy from "../GetUpdatedOnBy";

export const MediaUpdated = () => {
  const { log } = React.useContext(LogRenderContext);
  const { medias } = log.dataSnapshot;
  const mediasNew = log.changedFields?.medias?.[0] || [];
  const [media] = medias;
  const mediaName = mediasNew?.name || media?.name;
  const updatedAt = mediasNew?.updatedAt;
  const updatedBy = mediasNew?.updatedBy;
  return (
    <div className={styles.tabContainer}>
      <div className={styles.badgeContainer}>
        <div className={styles.campaignName}>{mediaName}</div>
        <div className={classNames(styles.badge, styles.badgeUpdated)}>
          <div>Updated</div>
        </div>
      </div>
      <GetUpdatedOnBy updatedAt={updatedAt} updatedBy={updatedBy} />
      <MediaInfoBlock media={media} mediaNew={mediasNew} />
    </div>
  );
};
